import { Http } from '@angular/http';
import { Injectable } from '@angular/core';

import { environment } from '../../../../environments/environment';
import { SessionParserService } from './session-parser.service';
import { ISessionManager, OnWbStateCallback } from './session-manager';

import { UserTypeManagerService, UserType } from '../usertype/user-type-manager.service';
import { WbService } from '../../wb.service';
import { LogService } from '../log/log.service';
@Injectable()
export class SessionManagerService implements ISessionManager {
    timer;
    constructor(private sessionParser: SessionParserService,
     private userTypeManager: UserTypeManagerService, private wbService: WbService, private http: Http, private log: LogService) {
        sessionParser.setSessionManager(this);
        console.log("Creating session manager service");
        this.boards[0] = { 'wbType': "WELCOME" };
    }
    startSendingWbStates(){
      var self = this;
      this.timer = setInterval(function() {
        try{
          self.getCurrentStates()
          self.log.sendlog();
        }catch(error){}
        }, environment.changeInterval)
    }
    callbacks = {};
    onDisconnected() {
        this.boards = [{ "wbType": "WELCOME" }]
    }
    unregisterWbStateCallback(c: OnWbStateCallback) {
        delete this.callbacks[c.getId()];
    }
    registerWbStateCallback(c: OnWbStateCallback) {
        for (let a in this.callbacks)
            if (this.callbacks[a] == c) return;
        this.callbacks[c.getId()] = c
    }
    setTeacherBoard(session) {

        this.boards = [{ "wbType": "TEACHER", groups: session.groups }];

    }
    currentPage
_loagPage(file, next) {
    debugger
    this.openFile(file, file.page + (next ? 1 : -1));
  }
  nextPage() {
      console.log("Got ", this.currentPage, this.currentFile)
      if (this.currentPage+1>=this.currentFile.pages)return;
    this._loagPage(this.currentFile, true);
  }
  prevPage() {
    if (this.currentPage==0)return;
    this._loagPage(this.currentFile, false);
  }
  fileUploads = false;
  currentFile = null;
getPage(page) {
    if (typeof +page != 'number') return;
    this.openFile(this.currentFile, +page - 1);
  }
 openFile(file, page) {

    console.log(file, page)
    this.currentPage = page;

    file.page = page;
    this.wbService.showFile(file);
  }
    previousStates = {}
    getCurrentStates(recording = false) {
        var states = []
        for (var c in this.callbacks) {
            var a = this.callbacks[c].getCurrentPageState();
            console.log('state', a)
            states.push(a)
            console.log("needs update", this.previousStates)
            console.log("recording", recording)
            console.log('previousState', this.previousStates[a.pageId])
            if (this.previousStates[a.pageId] === true || recording) {
                console.log("sending state", a)
                this.sessionParser.sendCurrentState(a.currentState, a);
                this.previousStates[a.pageId] = false;
            } else {
                console.log("state is the same no need to send")
            }

        }
        return states;
    }
    isInAGroup() {
        return this.session && this.session.type == 'group' && this.userTypeManager.getType() == UserType.TEACHER;
    }
    inGroups = false;
    isInGroup(){
        if (this.session && this.session.type=="group"){
            return true;
        }
        return false;
    }
    onGroupSelected(group) {
        this.sessionParser.sendGroupSelected(group);
        this.inGroups = true;
    }
    onExitFromGroup() {
        this.sessionParser.sendExitFromGroup();
        this.inGroups = false;
    }
    session;
    getCurrentSessionId(){
        return this.session.id;
    }
    onSession(session) {
        this.session = session;
        console.log("Session is ", session);
        this.sessionId = session.id;
        if (session.groups) {
            this.setTeacherBoard(session);
            this.session.type = "";
        } else {
            this.loadSession(session);
        }

    }
    sessions = [];
    boards = [];
    sessionId;
    private loadSession(session, canGoBack = false) {
        session.currentPages.sort(function (a, b) {
            return a.column - b.column;
        })
        console.log("Boards are ", session.currentPages)
        
        this.boards = session.currentPages;
        //  this.canGoBack = canGoBack
        var _this = this;
        setTimeout(function () {
            for (let i = 0; i < session.currentPages.length; i++) {
                let page = session.currentPages[i];
               // if (page.currentState && page.currentState.length > 0) {
                    if (page && page.history){
                        console.log("Bgoree", page.history)
                        page.history.sort(function(a, b){
                            console.log("Comparing ", a, b);
                            return a["id"]-b["id"];
                        })
                        console.log("Afterr", page.history)
                    }
                    _this.notifyCallbacksAboutCurrentState(page);
                //}

                //   if (session.currentPages[i].wbType == 'GRAPHIC' || session.currentPages[i].wbType == 'MEDIA') {//for materials loading file
                //    _this.pageId = session.currentPages[i].pageId;
                // }
                /*if (session.currentPages[i].states)
                  for (let j = 0; j < session.currentPages[i].states.length; j++) {
                    _this.wbService.gotState(session.currentPages[i].pageId, session.currentPages[i].states[j]);
                  }*/
            }
        }, 100);
    }
    notifyCallbacksAboutCurrentState(page) {
        console.log("Notifiyiing callbacks ", this.callbacks)
        for (let c in this.callbacks)
            this.callbacks[c].onSetCurrentPageState(page.currentState, page.pageId);
    }
    onPage(page) {

        this.currentFile = null;
        console.log("Will show page ", page)

        for (let i = 0; i < this.boards.length; i++) {
            if (this.boards[i].column == page.column) {
                if (this.boards[i].history)
                    page.history = this.boards[i].history;
                page.history.sort(function(a, b){
                    console.log("Comparing ", a, b);
                    return a["id"]-b["id"];
                })
                if (page.newPage)
                    page.history.push({ id: page.pageId })
                this.boards[i] = page;
                this.boards = this.boards.slice();
                var _this = this;

                setTimeout(function () {
                    //_this.wbService.onResize();
                    _this.notifyCallbacksAboutCurrentState(page);
                }, 200);
                break;
            }
        }

    }
    clearStates() {
        for (var c in this.callbacks) {

            this.callbacks[c].clearStates();
        }
    }
    onState(state, pageId) {
        for (var c in this.callbacks) {

            this.callbacks[c].onState(state, pageId);
        }
    }
    onCurrentState(s) {

        this.sessionParser.sendCurrentState(s.state, s.board);
    }
    setState(s) {
        if (!s || !s.board) return;
        this.sessionParser.sendState({ wbType: s.board.wbType, pageId: s.board.pageId, state: s.state });
    }
    getSessions() {
        this.sessionParser.getSessions();
    }
    onSessions(sessions) {
        this.sessions = sessions;
    }
    openSession(s) {
        this.sessionParser.getSession(s.id);
    }
    createSession(s) {
        this.sessionParser.createSession(s);
    }
    openPage(id) {
        this.getCurrentStates(false);
        this.sessionParser.getPage(id);
    }
    createPage(column, boardId, wbType, current) {
        this.sessionParser.createPage(column, boardId, wbType, current);

   }
   changeDesk(column, boardId, wbType){
      this.sessionParser.changeDesk(column, boardId, wbType);
   }
   sendWolframQuery(input) {
     let url = environment.wbBackendUrl+"wf/"+input.replace(" ", "+");
     let data = {
       input : input
     }
     console.log(data)
     
     return this.http.post(url, data)
   }

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/session/session-manager.service.ts